import * as React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import "./FormDialog.css";
import Button from "../Button/Button";
import close from '../../assets/icons/close.svg'
import { Tooltip } from '@mui/material';

export default function FormDialog(props) {

  const handleChange = (e) => {
    props.setInputValue(e.target.value)
  }

  return (
    <div>
      <Dialog className='custom-dialog' open={props.open} onClose={props.handleClose}>
        <DialogTitle className="title-dialog">{props.title}
        <Tooltip title='Close' arrow placement='bottom' >
          <img
            tabIndex={0}
            src={close}
            onClick={props.handleClose}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault(); // Prevent default behavior (e.g., scrolling)
                props.handleClose(); // Call the handleClose function
              }
            }}
            alt='/'
            style={{ cursor: "pointer" }} // Add cursor style to indicate interactivity
          />
          </Tooltip>

        </DialogTitle>
        <DialogContent className='content-dialog'>
          <h6>Name</h6>
          <input
            autoFocus
            id="name"
            type="text"
            value={props.inputValue}
            placeholder={props.placeHolder}
            className="MuiInputBase-input MuiInput-input inputbox"
            variant="standard"
            autoComplete="off"
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button
            className="cancel button-popup"
            text="Cancel"
            onClick={props.handleClose}
            heading="Cancel"
          />
          <Button
            className="create button-popup"
            text="Save"
            onClick={props.handleCreate}
            heading="Create"
            disable={!props.inputValue}
          />

        </DialogActions>
      </Dialog>
    </div>
  );
}